// extracted by mini-css-extract-plugin
export var card = "_6o-0";
export var content = "_6o-1";
export var contentLoading = "_6o-2";